import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { 
  MatAutocompleteModule, 
  MatInputModule, 
  MatProgressSpinnerModule 
} from '@angular/material';

import { MapboxPlaceInputComponent } from './mapbox-place-input.component';
import { MapboxAddressService } from '../../../services/mapbox/mapbox-address.service';

@NgModule({
  declarations: [MapboxPlaceInputComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatProgressSpinnerModule
  ],
  exports: [MapboxPlaceInputComponent],
  providers: [MapboxAddressService]
})
export class MapboxPlaceInputModule {}

